import React from "react";
import { Calendar as CalendarIcon, Clock, MapPin, X } from "lucide-react";

const DayEventsModal = ({
  show,
  date,
  events = [],
  styles,
  screenSize,
  theme,
  language,
  t,
  onClose,
  onEventClick,
}) => {
  if (!show || !date) return null;

  const isRTL = language === "ar";
  const dateLabel = date.toLocaleDateString(isRTL ? "ar-EG" : "en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div
        style={{ ...styles.modalContainer, maxWidth: screenSize.isMobile ? "95vw" : "480px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.modalHeader}>
          <div style={styles.modalTitleSection}>
            <div style={styles.modalIcon}>
              <CalendarIcon size={screenSize.isMobile ? 24 : 28} />
            </div>
            <div>
              <h2 style={styles.modalTitle}>{dateLabel}</h2>
              <p style={styles.modalSubtitle}>
                {events.length} {t.events || (isRTL ? "أحداث" : "events")}
              </p>
            </div>
          </div>
          <button onClick={onClose} style={styles.closeButton}>
            <X size={screenSize.isMobile ? 20 : 24} />
          </button>
        </div>

        <div style={styles.formContainer}>
          {events.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                padding: "24px 0",
                color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)",
              }}
            >
              {t.noEventsFound}
            </p>
          ) : (
            events.map((ev) => (
              <div
                key={ev.id}
                onClick={() => onEventClick(ev)}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "12px",
                  padding: screenSize.isMobile ? "12px" : "16px",
                  borderRadius: "12px",
                  marginBottom: "10px",
                  cursor: "pointer",
                  background:
                    theme === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.03)",
                  border:
                    theme === "dark"
                      ? "1px solid rgba(255,255,255,0.08)"
                      : "1px solid rgba(0,0,0,0.06)",
                  flexDirection: isRTL ? "row-reverse" : "row",
                  textAlign: isRTL ? "right" : "left",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    marginTop: "5px",
                    flexShrink: 0,
                    background: ev.color || "#2e7cba",
                  }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: screenSize.isMobile ? "14px" : "15px",
                      fontWeight: 700,
                      color: theme === "dark" ? "#fff" : "#1a1a1a",
                      marginBottom: "4px",
                    }}
                  >
                    {ev.title}
                  </div>
                  {ev.time && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
                        flexDirection: isRTL ? "row-reverse" : "row",
                        marginBottom: "2px",
                      }}
                    >
                      <Clock size={12} /> {ev.time}
                    </div>
                  )}
                  {ev.location && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)",
                        flexDirection: isRTL ? "row-reverse" : "row",
                      }}
                    >
                      <MapPin size={12} /> {ev.location}
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default DayEventsModal;
